// Toast notification utility for MCQ Assessment module
let toastContainer = null;

const createToastContainer = () => {
  if (!toastContainer) {
    toastContainer = document.createElement('div');
    toastContainer.className = 'toast-container';
    document.body.appendChild(toastContainer);
  }
  return toastContainer;
};

const showToast = ({ title, message, type = 'info', duration = 4000 }) => {
  const container = createToastContainer();
  
  const toast = document.createElement('div');
  toast.className = `toast ${type}`;
  
  toast.innerHTML = `
    <div class="toast-icon toast-icon-${type}"></div>
    <div class="toast-content">
      <div class="toast-title">${title}</div>
      ${message ? `<div class="toast-message">${message}</div>` : ''}
    </div>
    <button class="toast-close" onclick="this.parentElement.classList.add('toast-exit')" aria-label="Close">×</button>
  `;
  
  container.appendChild(toast);
  
  // Auto remove after duration
  setTimeout(() => {
    toast.classList.add('toast-exit');
    setTimeout(() => {
      if (toast.parentElement) {
        toast.remove();
      }
    }, 300);
  }, duration);
  
  return toast;
};

export const toast = {
  success: (title, message) => showToast({ title, message, type: 'success' }),
  error: (title, message) => showToast({ title, message, type: 'error' }),
  warning: (title, message) => showToast({ title, message, type: 'warning' }),
  info: (title, message) => showToast({ title, message, type: 'info' })
};
